// An evolving base value plus explicitly owned overrides. Removing a parent
// out of order cannot restore it over a child or leave a stale snapshot behind.
export function createValueOverrides<T>(initial: T, publish: (value: T) => void) {
    let base = initial
    const owners: { value: T }[] = []
    const refresh = () => publish(owners.length ? owners[owners.length - 1].value : base)
    return {
        get hasOverrides() { return !!owners.length },
        getBase: () => base,
        setBase(value: T) { base = value; refresh() },
        override(value: T) {
            const owner = { value }
            owners.push(owner)
            refresh()
            let released = false
            return () => {
                if (released) return
                released = true
                owners.splice(owners.indexOf(owner), 1)
                refresh()
            }
        },
    }
}
